module.exports = "<gw-quote\r\n        effective-date=\"effectiveDate\"\r\n        start-date=\"startDate\"\r\n        end-date=\"endDate\"\r\n        previous-premium=\"previousPremium\"\r\n        change-in-cost=\"changeInCost\"\r\n        new-premium=\"newPremium\"\r\n        taxes=\"taxes\"\r\n        new-premium-before-taxes=\"newPremiumBeforeTaxes\"\r\n        transaction-type=\"Renewal\"\r\n        always-show-payment-step=\"true\"\r\n></gw-quote>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gw-portals-policytransaction-renewal-bop-angular/quote/quote.html
// module id = 883
// module chunks = 0